import HTTP from "../HTTP";
import Jsona from "jsona";
import walletsHelper from "../helpers/wallets";

const dataFormatter = new Jsona();

export default {
  async show(id) {
    try {
      let response = await HTTP.normal.get(`/wallets/${id}`);
      return dataFormatter.deserialize(response.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async update(payload) {
    try {
      let response = await HTTP.normal.patch(
        `/wallets/${payload.id}`,
        walletsHelper.buildUpdateWalletRequestBody(payload)
      );
      return dataFormatter.deserialize(response.data);
    } catch (error) {
      throw error.response.data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/wallets.js